import React from "react";
import AdminCatalogRolesRoutes from "./AdminCatalogRolesRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminCatalogRolesScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Catalog Roles",
      page: "Admin Catalog Roles Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminCatalogRolesRoutes />
      </Track>
    </div>
  );
};

export default AdminCatalogRolesScreen;
